import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; // ✅ Correct import based on your folder

interface RoleProtectedRouteProps {
  allowedRoles: string[];
}

const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({
  allowedRoles,
}) => {
  const { isAuthenticated, student } = useAuth();

  if (!isAuthenticated || !student) {
    return <Navigate to="/login" replace />;
  }

  const studentRoles = [student.role]; // ✅ Wrap single role into array

  const hasAccess = studentRoles.some((role: string) =>
    allowedRoles.includes(role)
  );

  if (!hasAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default RoleProtectedRoute;
